import script from "./SchedulingSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./SchedulingSettings.vue?vue&type=script&setup=true&lang=js"

import "./SchedulingSettings.vue?vue&type=style&index=0&id=3d3c0088&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d3c0088"]])

export default __exports__